import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "disclaimer__wrapper" }
const _hoisted_2 = { class: "disclaimer__text" }
const _hoisted_3 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", {
        class: "disclaimer__description",
        innerHTML: $props.description
      }, null, 8 /* PROPS */, _hoisted_3)
    ])
  ]))
}